import classNames from "classname";

export function AsideText(props) {
	return (
		<div
			className={classNames("aside-text", {
				"background-text": props.background,
				"background-text--light": props.lightBackground,
				"background-text--light-blue": props.lightBlueBackground,
				"text-center": props.textCenter,
				"border-text": props.border,
			})}
		>
			{props.children}
		</div>
	);
}

export default AsideText;
